// ssr support
export const inBrowser = typeof window !== 'undefined'
export const ua = inBrowser && navigator.userAgent.toLowerCase()
export const isAndroid = ua && ua.indexOf('android') > 0



// WEBPACK FOOTER //
// ./node_modules/cube-ui/src/common/helpers/env.js